import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBottle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBottle"><Path d="M8.5 1V3H9V6.58579L6 9.58579V23H18V9.58579L15 6.58579V3H15.5V1H8.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBottle;
